import SearchDOBRange from "@app/components/SearchDOBRange";
import {
    LOCAL_STORAGE_USER_LOGIN_INFO
} from "@app/constants/Common";
import { Provinces } from "@app/constants/Provinces";
import { CandidateDetailLanguageMode } from "@app/constants/Tabs";
import CandidateSearchSummaryNotes from "@app/pages/candidate/detail/CandidateSearchSummaryNotes";
import { requestGetUserList } from "@app/services/UserService";
import { DateRange, InputYesNoSearch } from "@components";
import CandidateLanguageComponent from "@pages/candidate/commonview/language/CandidateLanguageComponent";
import CandidateContactPoint from "@pages/candidate/detail/CandidateContactPoint";
import CandidateCVInfo from "@pages/candidate/detail/CandidateCVInfo";
import CandidateJobSeeking from '@pages/candidate/detail/CandidateJobSeeking';
import CandidateLocation, { CandidateLocationMode } from "@pages/candidate/detail/CandidateLocation";
import CandidateOriginCard from "@pages/candidate/detail/CandidateOriginCard";
import CandidateSearchDVTJCUV from "@pages/candidate/detail/CandidateSearchDVTJCUV";
import CandidateSearchProcessNotes from "@pages/candidate/detail/CandidateSearchProcessNotes";
import CategoriesCard from "@pages/candidate/detail/CategoriesCard";
import ContactsImportantCard from "@pages/candidate/detail/ContactsImportantCard";
import CtvInfoCard from "@pages/candidate/detail/CtvInfoCard";
import FlowsCard from "@pages/candidate/detail/FlowsCard";
import GenderCard from "@pages/candidate/detail/GenderCard";
import HideShowStatusCard from "@pages/candidate/detail/HideShowStatusCard";
import NotesReferSupportCard from "@pages/candidate/detail/NotesReferSupportCard";
import CandidateCategories, { CandidateCategoriesMode } from "@pages/candidate/userinput/component/CandidateCategories";
import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import NLMySelfOrAll from "../detail/NLMySelfOrAll";

const InitSearchConditions = {
    'candidate_id': '',
    'local_area': '',
    'phone': '',
    'email': '',
    'only_user_input': false,
    'cv_content': '',
    'created_date': {
        start_date: '', end_date: ''
    },
    'created_by_user': "",
    'inputted_by_user': "",
    'keyword_conditions': [
        {field: 'last_name', label: 'Họ', condition: ''},
        {field: 'first_name', label: 'Tên', condition: ''},
        {field: 'origin_company', label: 'Company (TT gốc)', condition: ''},
        {field: 'title', label: 'Title', condition: ''},
        {field: 'company_note', label: 'Company note', condition: ''},
        {field: 'general_note', label: 'General note', condition: ''},
        {field: 'important_note', label: 'Important note', condition: ''},
    ],
    'locations': {
        local_nationality: '', local_ever_work_nationality: '', local_province_email: '', local_area: '', local_area_email: '', local_province: ''
    },
    'categories': {},
    'flows': {
        candidate_know_state: '',
        object_special: '',
        standard_search_ignore: '',
        input_me_list: '',
        block_state: '',
        candidate_type: '',
        flow_note: '',
        show_hide_state: '',
    },
    'contacts': {},
    'refer_checks': [],
    'relations': [],
    'personal': {},
    'dob_range': {
        paper_day_from: '',
        paper_day_to: '',
        paper_month_from: '',
        paper_month_to: '',
        paper_year_from: '',
        paper_year_to: '',
        paper_age_from: '',
        paper_age_to: '',
        actual_day_from: '',
    },
    'candidate_origin': {},
    'info_as_ctv': {},
    'notes': {},
    'summary_notes': {},
    'languages': {},
    'cv_info': {},
    'hide_show': {
        has_check_hide_show: false,
        select_users: [],
        show_hide_state: ''
    },
    'advances': {
        note_for_refer_support: '',
        check_only_search_advance_user_input: false,
    },
    'dvtjcuv_clients': {},
    'contact_points': {},
    'inputYesNo': {
        checkedFields: {}
    },
    'obj_languages': [],
    'current_tab': 'flow-categories-tab'
}

const SearchConditionInputNewModal = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [userSearchOptions, setUserSearchOptions] = useState([]);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [currentTab, setCurrentTab] = useState('flow-categories-tab');

    const {isShow, initialSearchConditions} = props;
    const {onSearch} = props;
    const {onClose} = props;

    const fetchUsers = async () => {
        const res = await requestGetUserList({});
        const userList = res.content.users;
        const userOptionList = userList.map(user => {
            return {value: user.id, label: user.email, id: user.id};
        });
        setUserSearchOptions([...userOptionList]);
        userOptionList.splice(0, 0, {value: "", label: "Chọn user", id: ""});
        setUserOptions(userOptionList);
    };

    useEffect(() => {
        if (initialSearchConditions) {
            setSearchConditions(initialSearchConditions);
        }
    }, [initialSearchConditions]);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)));
        }
    }, []);

    useEffect(() => {
        if (isShow && userLoginInfo.is_superuser) {
            fetchUsers();
        }
    }, [isShow]);

    useEffect(() => {
        if (provinceOptions.length === 0) {
            let provinces = [];
            Provinces.forEach(item => {
                provinces.push({
                    value: item,
                    label: item.charAt(0).toUpperCase() + item.slice(1)
                });
            });
            setProvinceOptions(provinces);
        }
    }, []);

    const setSearchPersonalConditionItem = (event) => {
        console.log('event.target.name', event.target.name);
        searchConditions.personal[event.target.name] = event.target.value;
        setSearchConditions({...searchConditions});
    };

    const onChangeCreatedUserCondition = (values) => {
        searchConditions.created_by_user = values;
        setSearchConditions({...searchConditions});
    };

    const onChangeInputtedUserCondition = (values) => {
        searchConditions.inputted_by_user = values;
        setSearchConditions({...searchConditions});
    };

    const setSearchOnlyInputByMyselfConditionItem = (event) => {
        const value = searchConditions[event.target.name];
        if (value) {
            onChangeInputtedUserCondition([]);
        }
        searchConditions[event.target.name] = !value;
        setSearchConditions({...searchConditions});
    };

    const onChangeCreateDate = (event) => {
        searchConditions.created_date[event.target.name] = event.target.value;
        setSearchConditions({...searchConditions});
    };

    const onSearchCandidates = () => {
        onSearch(searchConditions);
    };

    const onClearSearchCondition = () => {
        setSearchConditions(cloneDeep(InitSearchConditions));
    };

    const onTabClicked = (tabId) => {
        setCurrentTab(tabId);
        setSearchConditions({...searchConditions, current_tab: tabId});
    };

    // Handler functions for different sections
    const onChangeCategories = (newCategories) => {
        searchConditions.categories = newCategories;
        // Không cần vì nếu set lại sẽ bị setState vòng lặp vô hạn
        setSearchConditions({...searchConditions});
    };

    const onChangeFlows = (newFlows) => {
        searchConditions.flows = newFlows;
        // Không cần vì nếu set lại sẽ bị setState vòng lặp vô hạn
        // setSearchConditions({...searchConditions});
    };

    const onChangeInfoAsCtv = (values) => {
        searchConditions.info_as_ctv = values;
        setSearchConditions({...searchConditions});
    };

    // const onSaveNotes = (newNotes) => {
    //     searchConditions.advances = newNotes;
    //     setSearchConditions({...searchConditions});
    // };

    const onChangeLanguages = (values) => {
        searchConditions.languages = values;
        setSearchConditions({...searchConditions});
    };

    const onChangeObjLanguages = (values) => {
        searchConditions.obj_languages = values;
        setSearchConditions({...searchConditions});
    };

    const onChangeInputHideShowConditions = (value, field) => {
        if (field === 'has_check_hide_show') {
            searchConditions.hide_show[field] = !searchConditions.hide_show[field];
        } else {
            searchConditions.hide_show[field] = value;
        }
        setSearchConditions({...searchConditions});
    };

    const onChangeInputYesNo = (inputYesNo) => {
        searchConditions.inputYesNo = {...inputYesNo};
        setSearchConditions({...searchConditions});
    };

    return (
        <>
            <Modal show={isShow}
                   size={'xl'}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Tìm kiếm Person</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body style={{overflowY: 'auto', maxHeight: '70vh'}}>
                    <ul className='nav nav-tabs' role='tablist'>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'user-time-input-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#user-time-input-tab'
                               onClick={() => onTabClicked('user-time-input-tab')}>User & Time NL</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'flow-categories-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#flow-categories-tab'
                               onClick={() => onTabClicked('flow-categories-tab')}>Phân loại & phân luồng</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'contacts-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#contacts-tab'
                               onClick={() => onTabClicked('contacts-tab')}>Contacts</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'curriculum-vitae-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#curriculum-vitae-tab'
                               onClick={() => onTabClicked('curriculum-vitae-tab')}>CV</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'general-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#general-tab'
                               onClick={() => onTabClicked('general-tab')}>General</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'personal-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#personal-tab'
                               onClick={() => onTabClicked('personal-tab')}>Personal</a>
                        </li>
                        {userLoginInfo.is_superuser &&
                            <li className='nav-item'>
                                <a className={`nav-link ${currentTab === 'ctv-tab' ? 'active' : ''}`} 
                                   data-toggle='tab' href='#ctv-tab'
                                   onClick={() => onTabClicked('ctv-tab')}>CTV</a>
                            </li>
                        }
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'job-seeking-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#job-seeking-tab'
                               onClick={() => onTabClicked('job-seeking-tab')}>Job Seeking</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'note-refer-support-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#note-refer-support-tab'
                               onClick={() => onTabClicked('note-refer-support-tab')}>Note for NHỜ REFER, HỖ TRỢ</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'process-note-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#process-note-tab'
                               onClick={() => onTabClicked('process-note-tab')}>Process Note</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'language-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#language-tab'
                               onClick={() => onTabClicked('language-tab')}>Language</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link ${currentTab === 'custom-notes-tab' ? 'active' : ''}`} 
                               data-toggle='tab' href='#custom-notes-tab'
                               onClick={() => onTabClicked('custom-notes-tab')}>Notes</a>
                        </li>
                        {userLoginInfo.is_superuser &&
                            <li className='nav-item'>
                                <a className={`nav-link ${currentTab === 'dvtjcuv-tab' ? 'active' : ''}`} 
                                   data-toggle='tab' href='#dvtjcuv-tab'
                                   onClick={() => onTabClicked('dvtjcuv-tab')}>DVTJCUV</a>
                            </li>
                        }
                        {userLoginInfo.is_superuser &&
                            <li className='nav-item'>
                                <a className={`nav-link ${currentTab === 'contact-point-tab' ? 'active' : ''}`} 
                                   data-toggle='tab' href='#contact-point-tab'
                                   onClick={() => onTabClicked('contact-point-tab')}>Info as a Contact Point/Hiring Mgr</a>
                            </li>
                        }
                        {userLoginInfo.is_superuser &&
                            <>
                                <li className='nav-item'>
                                    <a className={`nav-link ${currentTab === 'mj-candidate-category-tab' ? 'active' : ''}`} 
                                       data-toggle='tab' href='#mj-candidate-category-tab'
                                       onClick={() => onTabClicked('mj-candidate-category-tab')}>To match job</a>
                                </li>
                                <li className='nav-item'>
                                    <a className={`nav-link ${currentTab === 'rc-candidate-category-tab' ? 'active' : ''}`} 
                                       data-toggle='tab' href='#rc-candidate-category-tab'
                                       onClick={() => onTabClicked('rc-candidate-category-tab')}>To receive Cdd</a>
                                </li>
                                <li className='nav-item'>
                                    <a className={`nav-link ${currentTab === 'inputYesNo-tab' ? 'active' : ''}`} 
                                       data-toggle='tab' href='#inputYesNo-tab'
                                       onClick={() => onTabClicked('inputYesNo-tab')}>NL rồi/chưa</a>
                                </li>
                            </>
                        }
                    </ul>
                    <div className='tab-content'>
                        {/* Flow Categories Tab */}
                        <div id='user-time-input-tab' className={`tab-pane ${currentTab === 'user-time-input-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            <NLMySelfOrAll 
                                userLoginInfo={userLoginInfo} initData={searchConditions}
                                onChange={condition => setSearchConditions({...searchConditions, ...condition})}
                            />
                            <HideShowStatusCard
                                        hideShow={searchConditions.hide_show}
                                        userSearchOptions={userSearchOptions}
                                        onChangeInputHideShowConditions={onChangeInputHideShowConditions}
                                        userLoginInfo={userLoginInfo}
                                    />
                            <DateRange
                                title={'Thời gian NL đầu tiên'}
                                startDate={searchConditions.created_date.start_date}
                                endDate={searchConditions.created_date.end_date}
                                onChangeStart={event => onChangeCreateDate(event)}
                                onChangeEnd={event => onChangeCreateDate(event)}
                            />
                        </div>
                        {/* Flow Categories Tab */}
                        <div id='flow-categories-tab' className={`tab-pane ${currentTab === 'flow-categories-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'flow-categories-tab' && (
                                <>
                                    
                                    <CategoriesCard
                                        initialCategories={searchConditions.categories}
                                        onChange={onChangeCategories}
                                        allInputInfo={{}}
                                        mode="Search"
                                        isEditCategories
                                    />
                                    <FlowsCard
                                        initialFlows={searchConditions.flows}
                                        onChange={onChangeFlows}
                                        userLoginInfo={userLoginInfo}
                                        allInputInfo={{}}
                                        candidateId={''}
                                        onOpenHistory={() => {}}
                                        mode="Search"
                                        isEditFlows
                                    />
                                </>
                            )}
                        </div>

                        {/* Contacts Tab */}
                        <div id='contacts-tab' className={`tab-pane ${currentTab === 'contacts-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'contacts-tab' && (
                                <>
                                    <ContactsImportantCard
                                        isEditContacts
                                        setIsEditContacts={() => {}}
                                        updateCandidateContacts={() => {}}
                                        contacts={searchConditions.contacts}
                                        userLoginInfo={userLoginInfo}
                                        onAddContactItem={(value, fieldName) => {
                                            searchConditions.contacts[fieldName] = (value);
                                            setSearchConditions({...searchConditions});
                                        }}
                                        mode="Search"
                                    />
                                </>
                            )}
                        </div>

                        {/* Curriculum Vitae Tab */}
                        <div id='curriculum-vitae-tab' className={`tab-pane ${currentTab === 'curriculum-vitae-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'curriculum-vitae-tab' && (
                                <CandidateCVInfo
                                    isEditCandidateCVs
                                    cvInfo={searchConditions.cv_info}
                                    onChange={cv => {
                                        searchConditions.cv_info = {...cv}
                                        setSearchConditions({...searchConditions})}
                                    }
                                    mode="Search"
                                />
                            )}
                        </div>

                        {/* General Tab */}
                        <div id='general-tab' className={`tab-pane ${currentTab === 'general-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'general-tab' && (
                                <CandidateOriginCard
                                    isEditCandidateOrigin
                                    candidateOrigin={searchConditions.candidate_origin}
                                    onChange={(origin) => {
                                        searchConditions.candidate_origin = {...origin}
                                        setSearchConditions({...searchConditions});
                                    }}
                                    allInputInfo={{}}
                                    mode="Search"
                                />
                            )}
                        </div>

                        {/* Personal Tab */}
                        <div id='personal-tab' className={`tab-pane ${currentTab === 'personal-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'personal-tab' && (
                                <>
                                    <CandidateLocation
                                        initialLocations={searchConditions.locations}
                                        isEditLocations
                                        setIsEditLocations={() => {}}
                                        updateCandidateLocations={() => {}}
                                        onChangeLocations={locations => {
                                            searchConditions.locations = locations;
                                            setSearchConditions({...searchConditions});
                                        }}
                                        mode={CandidateLocationMode.SEARCH}
                                    />
                                    <GenderCard
                                        isEditGender
                                        // setIsEditGender={() => {}}
                                        // updateCandidatePersonal={() => {}}
                                        initPersonal={searchConditions.personal}
                                        // stringToLowerCase={(str) => str?.toLowerCase() || ''}
                                        userLoginInfo={userLoginInfo}
                                        onChange={(personal) => {
                                            searchConditions.personal = {...personal}
                                            setSearchConditions({...searchConditions})
                                        }}
                                        allInputInfo={{}}
                                        mode="Search"
                                    />
                                    <SearchDOBRange
                                        initData={searchConditions.dob_range}
                                        onChange={(dobRange) => {
                                            searchConditions.dob_range = {...dobRange}
                                            setSearchConditions({...searchConditions})
                                        }}
                                    />
                                </>
                            )}
                        </div>

                        {/* CTV Tab */}
                        {userLoginInfo.is_superuser && (
                            <div id='ctv-tab' className={`tab-pane ${currentTab === 'ctv-tab' ? 'active' : 'fade'}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                {currentTab === 'ctv-tab' && (
                                    <CtvInfoCard
                                        initialInfoAsCtv={searchConditions.info_as_ctv}
                                        onChange={onChangeInfoAsCtv}
                                        mode="Search"
                                        isEditCtvInfo
                                    />
                                )}
                            </div>
                        )}

                        {/* Job Seeking Tab */}
                        <div id='job-seeking-tab' className={`tab-pane ${currentTab === 'job-seeking-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'job-seeking-tab' && (
                                <CandidateJobSeeking
                                    candidateId={''}
                                    isEdit
                                    initialJobSeeking={searchConditions.advances}    
                                    onChange={jobSeeking => {
                                        searchConditions.advances = jobSeeking;
                                        setSearchConditions({...searchConditions})}
                                    }
                                    mode="Search"
                                />
                            )}
                        </div>

                        {/* Note Refer Support Tab */}
                        <div id='note-refer-support-tab' className={`tab-pane ${currentTab === 'note-refer-support-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'note-refer-support-tab' && (
                                <NotesReferSupportCard
                                    initialNotes={searchConditions.advances}
                                    onChange={(notes) => {
                                        searchConditions.advances = notes;
                                        setSearchConditions({...searchConditions});
                                    }}
                                    mode="Search"
                                    isEditNotes
                                />
                            )}
                        </div>

                        {/* Process Note Tab */}
                        <div id='process-note-tab' className={`tab-pane ${currentTab === 'process-note-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'process-note-tab' && (
                                // <div className='card card-default'>
                                //     <div className='card-header'>
                                //         <h3 className='card-title text-bold'>Process Notes Search</h3>
                                //     </div>
                                //     <div className='card-body'>
                                //         <div className='input-group'>
                                //             <label className={'w-100'}>Process Note Content</label>
                                //             <input type='text' className='form-control'
                                //                    value={searchConditions || ''}
                                //                    name={'process_notes'}
                                //                    onChange={setSearchConditionItem}/>
                                //         </div>
                                //     </div>
                                // </div>
                                <CandidateSearchProcessNotes
                                    mode={'Search'}
                                    initProcessNote={searchConditions.advances}
                                    onChange={(notes) => {
                                        searchConditions.advances = notes;
                                        setSearchConditions({...searchConditions});
                                    }}
                                    isEditProcessNotes
                                 />
                            )}
                        </div>

                        {/* Language Tab */}
                        <div id='language-tab' className={`tab-pane ${currentTab === 'language-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'language-tab' && (
                                <CandidateLanguageComponent
                                    candidateId={''}
                                    initStrLanguages={searchConditions.languages}
                                    initObjLanguages={searchConditions.obj_languages}
                                    mode={CandidateDetailLanguageMode.SEARCH}
                                    onChange={(strLang, objLang) => {
                                        onChangeLanguages(strLang);
                                        onChangeObjLanguages(objLang);
                                    }}
                                />
                            )}
                        </div>

                        {/* Custom Notes Tab */}
                        <div id='custom-notes-tab' className={`tab-pane ${currentTab === 'custom-notes-tab' ? 'active' : 'fade'}`}
                             style={{height: '83vh', overflow: 'auto'}}>
                            {currentTab === 'custom-notes-tab' && (
                                <CandidateSearchSummaryNotes
                                initNotes={{...searchConditions.advances, ...searchConditions.summary_notes}}
                                onChange={(notes) => {
                                    searchConditions.advances = notes;
                                    searchConditions.summary_notes.content = notes.content;
                                    searchConditions.summary_notes.note = notes.note;
                                    setSearchConditions({...searchConditions});
                                }}
                                mode="Search"
                                />
                            )}
                        </div>

                        {/* DVTJCUV Tab */}
                        {userLoginInfo.is_superuser && (
                            <div id='dvtjcuv-tab' className={`tab-pane ${currentTab === 'dvtjcuv-tab' ? 'active' : 'fade'}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                {currentTab === 'dvtjcuv-tab' && (
                                    <CandidateSearchDVTJCUV
                                        initDVTJCUV={searchConditions.dvtjcuv_clients}
                                        onChange={dvtjcuv => {
                                            searchConditions.dvtjcuv_clients = dvtjcuv;
                                            setSearchConditions({...searchConditions});
                                        }}
                                    />
                                )}
                            </div>
                        )}

                        {/* Contact Point Tab */}
                        {userLoginInfo.is_superuser && (
                            <div id='contact-point-tab' className={`tab-pane ${currentTab === 'contact-point-tab' ? 'active' : 'fade'}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                {currentTab === 'contact-point-tab' && (
                                    // <div className='card card-default'>
                                    //     <div className='card-header'>
                                    //         <h3 className='card-title text-bold'>Contact Point Search</h3>
                                    //     </div>
                                    //     <div className='card-body'>
                                    //         <div className='input-group'>
                                    //             <label className={'w-100'}>Contact Point Content</label>
                                    //             <input type='text' className='form-control'
                                    //                    value={searchConditions || ''}
                                    //                    name={'contact_point'}
                                    //                    onChange={setSearchConditionItem}/>
                                    //         </div>
                                    //     </div>
                                    // </div>
                                    <CandidateContactPoint
                                        initContactPoint={searchConditions.contact_points}
                                        isEditContactPoint
                                        onChange={data => {
                                            searchConditions.contact_points = data;
                                            setSearchConditions({...searchConditions});
                                            }
                                        }
                                        mode="Search"
                                    />
                                )}
                            </div>
                        )}

                        {/* To Match Job Tab */}
                        {userLoginInfo.is_superuser && (
                            <div id='mj-candidate-category-tab' className={`tab-pane ${currentTab === 'mj-candidate-category-tab' ? 'active' : 'fade'}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                {currentTab === 'mj-candidate-category-tab' && (
                                    <>
                                        <CandidateCategories
                                            categoryMode={CandidateCategoriesMode.MJ_CATEGORY}
                                            initialCategories={searchConditions.categories}
                                            onChange={onChangeCategories}
                                            mode="Search"
                                            isEdit
                                        />
                                    </>
                                )}
                            </div>
                        )}

                        {/* To Receive Cdd Tab */}
                        {userLoginInfo.is_superuser && (
                            <div id='rc-candidate-category-tab' className={`tab-pane ${currentTab === 'rc-candidate-category-tab' ? 'active' : 'fade'}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                {currentTab === 'rc-candidate-category-tab' && (
                                    <>
                                        <CandidateCategories
                                            categoryMode={CandidateCategoriesMode.RC_CATEGORY}
                                            initialCategories={searchConditions.categories}
                                            onChange={onChangeCategories}
                                            mode="Search"
                                            isEdit
                                        />
                                        <CandidateLocation
                                            initialLocations={searchConditions.locations}
                                            isEditLocations
                                            setIsEditLocations={() => {}}
                                            updateCandidateLocations={() => {}}
                                            onChangeLocations={locations => {
                                                searchConditions.locations = locations;
                                                setSearchConditions({...searchConditions});
                                            }}
                                            mode={CandidateLocationMode.SEARCH_RC}
                                        />
                                        <CandidateLanguageComponent
                                            candidateId={''}
                                            initStrLanguages={searchConditions.languages}
                                            initObjLanguages={searchConditions.obj_languages}
                                            mode={CandidateDetailLanguageMode.SEARCH_RC}
                                            onChange={(strLang, objLang) => {
                                                onChangeLanguages(strLang);
                                                onChangeObjLanguages(objLang);
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                        )}

                        <div id='inputYesNo-tab'
                            className={`tab-pane ${currentTab === 'inputYesNo-tab' ? 'active' : 'fade'}`}
                            style={{height: '83vh', overflow: 'auto'}}>
                            <InputYesNoSearch
                                initInputYesNo={searchConditions.inputYesNo}
                                onChange={onChangeInputYesNo}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type='button'
                            className='btn btn-default'
                            onClick={onClearSearchCondition}>
                        Clear
                    </button>
                    <button type='button'
                            className='btn btn-primary'
                            onClick={() => {
                                onSearchCandidates();
                                onClose();
                            }}>
                        <i className='fas fa-search mr-2'/>
                        Search
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SearchConditionInputNewModal;
